<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18 4H6a1 1 0 00-.83.45l-3 4.49a1 1 0 00.07 1.21l9 10.5a1 1 0 001.52 0l9-10.5a1 1 0 00.07-1.21l-3-4.49A1 1 0 0018 4zM7.38 10.5l2.21 5.16-4.42-5.16zM11.5 6v2.5h-3L9.6 6zm2.9 0l1.11 2.5h-3V6zm-1.9 4.5h3l-3 7.06zm-1 0v7.06l-3-7.06zm5.12 0h2.21l-4.42 5.16zm2.51-2H16.6L15.49 6h2zM6.54 6h2L7.4 8.5H4.87z"/></svg>